export type DatePresetId =
  | 'today'
  | 'past_week'
  | 'past_month'
  | 'past_quarter'
  | 'past_year';

export const DATE_PRESET_DEFS: { id: DatePresetId; label: string }[] = [
  { id: 'today', label: 'Today' },
  { id: 'past_week', label: 'Last 7 days' },
  { id: 'past_month', label: 'Last 30 days' },
  { id: 'past_quarter', label: 'Last 90 days' },
  { id: 'past_year', label: 'Last 12 months' },
];

export const getPresetLabel = (id: string) =>
  DATE_PRESET_DEFS.find((p) => p.id === id)?.label || id;
export type DateRange = { startISO: string; endISO: string };

export const presetToLocalRange = (id: DatePresetId): DateRange => {
  const now = new Date();
  const endLocal = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,
    0,
    0,
    0,
  );
  const startLocal = new Date(endLocal.getTime());
  switch (id) {
    case 'today':
      break;
    case 'past_week':
      startLocal.setDate(startLocal.getDate() - 6);
      break;
    case 'past_month':
      startLocal.setDate(startLocal.getDate() - 29);
      break;
    case 'past_quarter':
      startLocal.setDate(startLocal.getDate() - 89);
      break;
    case 'past_year':
      startLocal.setFullYear(startLocal.getFullYear() - 1);
      startLocal.setDate(startLocal.getDate() + 1);
      break;
  }
  const nextDay = new Date(
    endLocal.getFullYear(),
    endLocal.getMonth(),
    endLocal.getDate() + 1,
    0,
    0,
    0,
    0,
  );
  return { startISO: startLocal.toISOString(), endISO: nextDay.toISOString() };
};

export const customToLocalRange = (
  fromYMD: string,
  toYMD: string,
): DateRange => {
  const [fy, fm, fd] = fromYMD.split('-').map(Number);
  const [ty, tm, td] = toYMD.split('-').map(Number);
  const start = new Date(fy, fm - 1, fd, 0, 0, 0, 0);
  const endNext = new Date(ty, tm - 1, td + 1, 0, 0, 0, 0);
  const startISO = start.toISOString();
  const endISO = endNext.toISOString();
  return { startISO, endISO };
};

export const normalizeCustomOrder = (a: string, b: string) => {
  const da = new Date(a);
  const db = new Date(b);
  if (da <= db) return [a, b];
  return [b, a];
};
